/* eslint-disable no-param-reassign */

import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { ActionWithPayload, MakerSelectors, TableFilters } from 'types';

type State = Record<string, TableFilters>;

interface Reducers extends SliceCaseReducers<State> {
  setFilters: CaseReducer<State, ActionWithPayload<{ key: string; filters: TableFilters }>>;
  resetFiltersFrom: CaseReducer<State, ActionWithPayload<{ key: string }>>;
  reset: CaseReducer<State>;
}

interface ExtraSelectors extends MakerSelectors<State> {
  getFilters: (state: State) => (key: string) => TableFilters;
}

const tablesFiltersInitialState = {};

export const tablesFilters = createSlice<State, Reducers, ExtraSelectors>({
  name: 'tablesFilters',
  initialState: tablesFiltersInitialState,
  reducers: {
    setFilters: (state, { payload: { key, filters } }) => {
      state[key] = filters;
    },
    resetFiltersFrom: (state, { payload: { key } }) => {
      // eslint-disable-next-line
      const { [key]: ommited, ...remainderState } = state;
      return remainderState;
    },
    reset: () => tablesFiltersInitialState,
  },
  extraSelectors: {
    getFilters: (state) => (key) => state[key] || {},
  },
});
